// extracted by mini-css-extract-plugin
export default {"container":"DateValue_container__+m6Jc","title":"DateValue_title__l1GcZ","value":"DateValue_value__H-noN"};